var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessagefooter(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.806641,
    width: 48,
    height: 48,
    rx: 8,
    fill: "#457AD0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 33.4733C14.7375 33.4733 14.2276 33.2614 13.8037 32.8374C13.3797 32.4135 13.1674 31.9032 13.1667 31.3067V18.3067C13.1667 17.7108 13.379 17.201 13.8037 16.777C14.2283 16.3531 14.7382 16.1407 15.3333 16.14H32.6667C33.2625 16.14 33.7727 16.3523 34.1974 16.777C34.6221 17.2017 34.834 17.7116 34.8333 18.3067V31.3067C34.8333 31.9025 34.6213 32.4128 34.1974 32.8374C33.7735 33.2621 33.2632 33.4741 32.6667 33.4733H15.3333ZM24 25.89L32.6667 20.4733V18.3067L24 23.7233L15.3333 18.3067V20.4733L24 25.89Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagefooter);
export default __webpack_public_path__ + "static/media/messagefooter.1c3804574fb61353b0e23b572006d7a8.svg";
export { ForwardRef as ReactComponent };